import { Component } from '@angular/core';

@Component({
    selector: 'app-alert-warning',
    templateUrl: './alert-warning.component.html',
    styleUrls: ['./alert-warning.component.scss'],
    standalone: false
})
export class AlertWarningComponent {

}
